export const Colors = {
  light: {
    primaryColor: "#303030",
    greenColor: "#00d2133d",
    secondaryColor: "#98C355",
    background: "#ffffff",
    newBackground: "#ffffff",
    textColor: "#303030",
    // active: "#e5e5e5",
    active: "#F6F6F6",
    tablebody: "#E7E7E7",
    activeTimeline: "#00B100",
    noActiveTimeline: "#C6C6C6",
    secondBackground: "#fff",
    tableBackground: "#d1d1d1",
    navBackground: "#fff",
    borderColor: "#dbdbdb",
    secBorderColor: "#c1c1c1",
    glass: "rgb(0,0,0,0.06)",
    headerBgColor: "#2982ff",
    newHeaderBgColor: "#2982ff",
    checkBoxColor: "#0d6efd",
    tableBgColor: "#0056D2",
    borderColor: "#3B4CFF",
    redColor: "#ff0000",
    searchColor: "#404975",
    softPurpleColor: "#6E7ED2",
    darkPurpleColor: "#232F69",
    inputColor: "#a9a9a9",
    pillColor: "#D8D8D8",
    sidebarColor: "#17214f",
    onBoardColor: "#3b4a94",
    sideDropDownColor: "#C8D0DF",
    newLightColor: "#0BBBDD",
    v2LigthColor: "#F6F9FF",
    v2ButtonColor: "#697bd2",
    v2SearchColor: "#cecece",
    sidebarText: "#d8e2f3",
    paginationColor: "#d8d8d8",
    verification: "#eee",
    textColorWhite: "#fff",
    PCF1: "#F4F4FB",
    PCF4: "#D9DCF2",
    PCFList9: "#D9DCF2",
    PCFList8: "#e5e5e5",
    PCFList5: "#F0F1FA",
    PCFList4: "#C6C8D21A",
    PCFList3: "#F7F8FC",
    PCFList2: "#E3E3E8",
    PCFBorderColor: "#E3E3E8",
    onboardColor: "#5764C7",
    inactiveToggleView: "#E8EBFF",
    activeToggleView: "#F0F4FF",
    activeToggleViewIcon: "#6C7A93",
    inactiveToggleViewIcon: "#1C1E2B",
    tableBackground1: '#F3F6FF',
    tableBorder: '#E0E4FF',
    tableCellActive: '#D4E0FF',
    tableCellActiveBorder: '#A1ACFF',
    //start for blueOnion
    dashboardBackground: '#F2F3F7',
    cardBackground: '#FFFFFF',
    cardBorder: '#E3E3E9',
    scope1: '#C2E1FF',
    scope2: '#3698FC',
    scope3: '#074183',
    emissionMitigation: '#FFBA4F',
    progressBar: '#3698FC',
    progressBarBackground: '#E7F4FF',
    toggleBackground: '#1890FF',
    toggleCircle: '#FFFFFF',
    btnBackgroundBlue: '#3698FC',
    btnBackgroundAnother: '#EEEEF4',  
    btnText: "white",
    btnTextAnother: "black",
    //end for blueOnion    
  },
  dark: {
    primaryColor: "#C6C6C6",
    secondaryColor: "#5E5E5E",
    background: "linear-gradient(65deg,#101841,#202b60)",
    newBackground: "rgb(23 31 95)",
    textColor: "#c6c6c6",
    active: "#202b60",
    tablebody: "#202b60",
    activeTimeline: "#2f528f",
    noActiveTimeline: "#ffffff",
    secondBackground: "#182149",
    tableBackground: "#182149",
    navBackground: "#202b60",
    borderColor: "#202b60",
    secBorderColor: "#696969",
    glass: "rgb(255,255,255,0.06)",
    headerBgColor: "linear-gradient(180deg,#010849,#1d256c)",
    newHeaderBgColor: "rgb(16 26 68)",
    tableBgColor: "#000534",
    backgrounColor: "#010849",
    greyColor: "#717171",
    buttonColor: "#2D3C86",
    sidebarColor: "#d8e2f3",
    sideDropDownColor: "#C8D0DF",
    sidebarText: "#17214f",
    verification: "#21265A",
    PCFBorderColor: "#29327A",
    PCF1: "#182149",
    PCF2: "#2c366c",
    PCF3: "#5161B6",
    PCF4: "#182149",
    PCFGreen: "#00B100",
    PCFOrange: "#FFA51F",
    PCFList9: "#2d3c86",
    PCFList8: "rgba(153, 255, 175, 0.10)",
    PCFList7: "#161F4D",
    PCFList6: "#1A2150",
    PCFList5: "#1B2150",
    PCFList4: "#1e245a",
    PCFList3: "#202760",
    PCFList2: "#29327a",
    PCFList1: "#3845A8",
    PCFList0: "#202760",
    onboardColor: "#5764C7",
    inactiveToggleView: "#283177",
    activeToggleView: "#1B2150",
    activeToggleViewIcon: "#C6C8D2",
    inactiveToggleViewIcon: "#F9F9FA",
    tableBackground1: '#232A67',
    tableBorder: '#1B2150',
    tableCellActive: '#3845A8',
    tableCellActiveBorder: '#7580D1',
    //start blueOnion dashboard
    cardBackground: '#151e47',
    cardBorder : '#1C285F',
    scope1: '#C2E1FF',
    scope2: '#3698FC',
    scope3: '#074183',
    emissionMitigation: '#1CB783',
    progressBar : '#3698FC',
    progressBarBackground: '#484C5C',
    toggleBackground: '#101737',
    toggleCircle: '#484C5C',
    btnBackgroundBlue: '#3698FC',
    btnBackgroundAnother: '#1C285F', 
    btnText: "white",
    btnTextAnother: "grey",
    //end blueOniion dashboard
  },
  Dark: ["#000000", "#303030", "#5E5E5E", "#919191", "#C6C6C6", "#F6F6F6", "#6c7783", "#5161B6", "#5A70E2", "#a8d08c"],
  Chart_Color: [`#f44336`, `#e91e63`, `#9c27b0`, `#673ab7`, `#2196f3`, `#009688`, `#ffc107`, `#ff5722`, `#5D4037`],
  // fuel: "#FF3400",
  // fuelLight: "#f4b183",
  // fuelBaseline: "red",
  medium: "#ffa700",
  low: "#FF0000",
  // low: "#00B100",
  tetradic: ["#202b60", "#60204B", "#206035", "#605520"],
  triadic: ["#202B60", "#60202B", "#2B6020"],
  mono: ["#202b60", "#2D3C86"],
  energy: "#ff5c00",
  orange: "#CA4A02",
  water: "#2982ff",
  blue: "#0056D2",
  white: "#ffffff",
  greenMaterial: "#04c500",
  darkBlue: "#182149",
  primaryBule: "#202b60",
  lightBlue: "#2D3C86",
  buttonColor: "linear-gradient(45deg,#202b60,#2D3C86)",
  buttonHoverColor: "linear-gradient(#2D3C86,#182149)",
  // activeColor: "#919191"
  shadow: "rgb(0 0 0 / 30%) 2px 3px 10px",
  login_shadow: "rgb(0 0 0 / 100%) 2px 3px 10px",
  buttonShadow: "0px 3.333px 20px 0px rgba(10, 13, 31, 0.08)",
  activeGroup: "#333F99",
  buttonRedColor: "#d02f47",
  greyColor: '#AAACBB',
  
  //blueOnion
  boBackground: '#F2F3F7',
  boSideBarColor: '#D9E2F2',
  bONavColor:'#0C124B',
  bOFontFamiliy:'Poppins Medium',
  bOBodytextColor:'#4B4B4B',
  bOSectionFontFamily: 'Poppins',
  bOSectionTextColor:'#27272A',
  bOPrimaryButton:"#3698FC",
  bOSecondaryButton:"#E7F4FF",
  
};

export const invertDark = (theme) => {
  return theme === "dark" ? "#C6C6C6" : "#303030";
};

export const invertDarkSolid = (theme) => {
  return theme === "dark" ? "#fff" : "#000";
};


